import strings from '../../Localization/Localization';

import {
  getTransatelOptions
} from '../../API/TransatelMVNO'

import {
  fetchProducts
} from '../../API/Products'

let product = {
  fieldKey: "product",
  label: strings.form.transatelDataRecharge.product.label,
  type: "dropdownEntity",

  validators: [],

  showEmpty: true,
  filterOptions: (product) => product.contract.length === 0 && (product["active_quote"] === true || product["active_order"] === true || product["active_ticket"] === true),
  loader: {
    id: "products",
    loader: fetchProducts,
    loaderRequire: () => true,
    loaderArguments: () => []
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let transatelPreviousThreshold = {
  fieldKey: "transatel_previous_threshold",
  label: strings.form.transatelDataRecharge.transatelPreviousThreshold.label,
  type: "dropdownEntity",

  validators: [],

  showEmpty: true,
  filterOptions: (option) => option["transatel_group"] === "data_threshold",
  loader: {
    id: "transatel_options",
    loader: getTransatelOptions,
    loaderRequire: () => true,
    loaderArguments: () => [],
    dataTransformation: (data) => data.result.data
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let transatelNextThreshold = {
  fieldKey: "transatel_next_threshold",
  label: strings.form.transatelDataRecharge.transatelNextThreshold.label,
  type: "dropdownEntity",

  validators: [],

  showEmpty: true,
  filterOptions: (option) => option["transatel_group"] === "data_threshold",
  loader: {
    id: "transatel_options",
    loader: getTransatelOptions,
    loaderRequire: () => true,
    loaderArguments: () => [],
    dataTransformation: (data) => data.result.data
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

/*
let transatelOptions = {
  fieldKey: "transatel_options_object",
  type: 'configurableField',
  label: "",
  validators: [],

  subField: (value, getValues, getExtraValues) => {
    let extraValues = getExtraValues();

    let fields = [];

    if(extraValues.transatelOptions["request_status"] === 200) {
      extraValues.transatelOptions.result.data.forEach((transatelOption, i) => {
        if(transatelOption["transatel_group"] === "data_threshold") {
          return;
        }
        let field = null;
        let valid = false;
        switch(transatelOption["option_type"]) {
          case "group":
            if(fields.some((field) => field.fieldKey === `transatel_option-${transatelOption["transatel_group"]}`)) {
              field = fields.find((field) => field.fieldKey === `transatel_option-${transatelOption["transatel_group"]}`);
            }
            else {
              valid = true;
              field = {
                fieldKey: `transatel_option-${transatelOption["transatel_group"]}`,
                type: "dropdown",
                label: strings.form.transatelMobileProduct.transatelOptions.custom[transatelOption["transatel_group"]],
                validators: [],

                showEmpty: true,
                options: []
              }
            }
            field.options.push({
              value: transatelOption["transatel_reference"],
              label: transatelOption["name"],
            });
            break;
          case "onoff":
            valid = true;
            field = {
              fieldKey: transatelOption["transatel_reference"],
              type: "switch",
              label: transatelOption["name"],
              validators: [],
              defaultValue: false
            }
            break;
          default:
            console.error("unknown option_type");
        }

        if(valid) {
          fields.push(field);
        }
      });
    }

    return {
      subForm: {
        formKey: "transatel_options",
        fields: fields
      }
    }
  },
  subFieldConf: {
    label: (value) => strings.form.transatelMobileProduct.transatelOptions.label,
    type: (value) => 'subform',
    disabled: () => false,
    validators: (value) => []
  },
}
*/

export const form = {
  formKey: "transatelDataRecharge",
  fields: [
    product,
    transatelPreviousThreshold,
    transatelNextThreshold
  ],
}
